import { useEventAttachmentUploadSuccessful } from 'entities/Attachment'
import { Attachment } from 'entities/Attachment/model/Attachment'
import { type MessageFieldStore } from 'widgets/MessageField'

export const useMessageFiledEventAttachmentUploadSuccessful = (
  messageFieldStore: MessageFieldStore
) => {
  const { recentStore } = messageFieldStore

  useEventAttachmentUploadSuccessful(({ attachment }) => {
    const attachmentMedia = new Attachment({ responseMedia: attachment })
    const attachmentUpload = new Attachment({ responseUpload: attachment })

    messageFieldStore.addAttachment(attachmentMedia, true)
    recentStore.addAttachmentRecent(attachmentUpload, true)
  })
}
